import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
    selector: 'p[confermaCambioFr]',
  templateUrl: 'conferma-cambio-fr.component.html',
  host: { '[class.active]': '\'true\'', '[class.singlecheckbox]': '\'true\'', '[class.conferma_accettazione]': '\'true\'' }
})

export class ConfermaCambioFrComponent implements OnInit {

  @Output()
  onReturn: EventEmitter<boolean> = new EventEmitter();

  randomEnd: string;
  modelCheck: boolean = false;

  ngOnInit() {
    this.randomEnd = '' + Math.round(Math.random() * 100000);
  }

  modelChanged() {
    this.onReturn.emit(this.modelCheck);
  }
}
